<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="visible"
    width="720px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
    @close="visible = false"
  >
    <el-form
      :model="form"
      ref="form"
      :rules="isViewMode ? {} : rules"
      label-width="100px"
      label-position="right"
      style="padding-top: 8px; padding-bottom: 20px;"
    >
      <el-row>
        <el-col :span="24">
          <el-form-item label="属性名称" prop="name">
            <el-input v-model.trim="form.name" maxlength="50" show-word-limit placeholder="请输入属性名称" :disabled="isViewMode"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="属性备注">
            <el-input v-model.trim="form.remark" maxlength="200" show-word-limit placeholder="请输入属性备注（选填）" :disabled="isViewMode"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="属性值类型" prop="valueType">
            <el-radio-group v-model="form.valueType" @change="handleValueTypeChange" :disabled="isViewMode">
              <el-radio label="SINGLE">单选</el-radio>
              <el-radio label="MULTI">多选</el-radio>
              <el-radio label="CUSTOM">自定义输入</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <!-- 单选/多选：候选值列表 -->
        <template v-if="form.valueType === 'SINGLE' || form.valueType === 'MULTI'">
          <el-col :span="24">
            <el-form-item label="候选值">
              <el-button v-if="!isViewMode" size="mini" type="primary" @click="addValueRow">新增行</el-button>
              <el-table :data="form.valueList" border size="small" style="margin-top:8px;">
                <el-table-column label="属性值" min-width="200">
                  <template slot-scope="{ row }">
                    <el-input v-if="!isViewMode" v-model.trim="row.optionValue" maxlength="20" show-word-limit size="small" placeholder="请输入属性值"></el-input>
                    <span v-else>{{ row.optionValue }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="默认" width="80" align="center">
                  <template slot-scope="{ row, $index }">
                    <el-checkbox v-model="row.isDefault" @change="handleDefaultChange($index)" :disabled="isViewMode"></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column v-if="!isViewMode" label="操作" width="80" align="center">
                  <template slot-scope="{ $index }">
                    <el-button type="text" size="mini" @click="removeValueRow($index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </template>

        <!-- 自定义输入：规则 -->
        <template v-if="form.valueType === 'CUSTOM'">
          <el-col :span="24">
            <el-form-item label="属性值规则" prop="valueRule">
              <el-radio-group v-model="form.valueRule" @change="handleValueRuleChange" :disabled="isViewMode">
                <el-radio label="SHORT_TEXT">短文本</el-radio>
                <el-radio label="TEXT_AREA">文本域</el-radio>
                <el-radio label="TIME">时间</el-radio>
                <el-radio label="NUM">数值</el-radio>
                <el-radio label="FILE">附件</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>

          <template v-if="form.valueRule === 'NUM'">
            <el-col :span="12" key="num-unit-flag">
              <el-form-item label="是否有单位">
                <el-radio-group v-model="form.hasUnitFlag" :disabled="isViewMode">
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col v-if="form.hasUnitFlag" :span="12" key="num-unit-name">
              <el-form-item label="单位" prop="unitName">
                <el-select v-model="form.unitName" placeholder="请选择单位" filterable :disabled="isViewMode" style="width:100%;">
                  <el-option v-for="item in unitOptions" :key="item.optionName" :label="item.optionName" :value="item.optionName"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" key="num-range">
              <el-form-item label="是否区间">
                <el-radio-group v-model="form.isRange" :disabled="isViewMode">
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12" key="num-decimal">
              <el-form-item label="小数位数">
                <el-select v-model="form.decimalPlaces" :disabled="isViewMode">
                  <el-option v-for="n in [0,1,2,3,4]" :key="n" :label="n + '位'" :value="n"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </template>

          <template v-if="form.valueRule === 'TIME'">
            <el-col :span="12" key="time-range">
              <el-form-item label="是否区间">
                <el-radio-group v-model="form.isRange" :disabled="isViewMode">
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12" key="time-precision">
              <el-form-item label="时间精度" prop="timePrecision">
                <el-select v-model="form.timePrecision" placeholder="请选择时间精度" :disabled="isViewMode" style="width:100%;">
                  <el-option v-for="item in timePrecisionList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </template>

          <template v-if="form.valueRule === 'FILE'">
            <el-col :span="24" key="file-types">
              <el-form-item label="附件类型">
                <el-select v-model="form.attachmentTypeList" multiple placeholder="请选择允许的附件类型" style="width:100%;" :disabled="isViewMode">
                  <el-option v-for="t in attachmentTypeOptions" :key="t" :label="t" :value="t"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" key="file-size">
              <el-form-item label="大小限制">
                <el-select v-model="form.attachmentSize" :disabled="isViewMode">
                  <el-option label="10M（默认）" :value="10"></el-option>
                  <el-option label="20M" :value="20"></el-option>
                  <el-option label="50M" :value="50"></el-option>
                  <el-option label="100M" :value="100"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </template>
        </template>
      </el-row>
    </el-form>

    <div slot="footer">
      <template v-if="isViewMode">
        <el-button @click="visible = false">关 闭</el-button>
      </template>
      <template v-else>
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" :loading="submitting" @click="handleSubmit">{{ currentId ? '更 新' : '保 存' }}</el-button>
      </template>
    </div>
  </el-dialog>
</template>

<script>
import { addAttribute, updateAttribute, getAttributeDetail } from '@/api/attributeDict.js';
import { dictionaryData } from '@/api/inquiryForm';

export default {
  name: 'EditAttributeDialog',
  data () {
    return {
      visible: false,
      submitting: false,
      isViewMode: false,
      dialogTitle: '新增属性',
      currentId: null,
      currentSource: 'TENANT',
      defaultCategoryTenantId: null,
      attachmentTypeOptions: ['jpg', 'jpeg', 'png', 'gif', 'pdf', 'docx', 'xls', 'xlsx', 'csv', 'zip'],
      timePrecisionList: [
        { label: '年', value: '年' },
        { label: '月', value: '月' },
        { label: '天', value: '天' },
        { label: '秒', value: '秒' },
      ],
      unitOptions: [],
      form: this.emptyForm(),
    };
  },
  computed: {
    rules () {
      return {
        name: [{ required: true, message: '请输入属性名称', trigger: ['blur', 'change'] }],
        valueType: [{ required: true, message: '请选择属性值类型', trigger: ['blur', 'change'] }],
        valueRule: [{
          required: this.form.valueType === 'CUSTOM',
          message: '请选择属性值规则',
          trigger: ['blur', 'change'],
        }],
        timePrecision: [{
          required: this.form.valueRule === 'TIME',
          message: '请选择时间精度',
          trigger: ['blur', 'change'],
        }],
        unitName: [{
          required: this.form.valueRule === 'NUM' && this.form.hasUnitFlag,
          message: '请选择单位',
          trigger: ['blur', 'change'],
        }],
      };
    },
  },
  methods: {
    emptyForm () {
      return {
        name: '',
        remark: '',
        valueType: '',
        valueRule: '',
        timePrecision: '',
        hasUnitFlag: false,
        unitName: '',
        isRange: false,
        decimalPlaces: 2,
        attachmentTypeList: [],
        attachmentSize: 10,
        valueList: [],
        attributeCategoryTenantId: null,
        attributeCategoryPlatformId: null,
      };
    },
    open ({ id = null, viewMode = false, categoryTenantId = null, categoryPlatformId = null, source = 'TENANT' }) {
      this.currentId = id;
      this.isViewMode = viewMode;
      this.currentSource = source;
      this.defaultCategoryTenantId = categoryTenantId;
      this.dialogTitle = viewMode ? '属性详情' : id ? '编辑属性' : '新增属性';
      this.form = this.emptyForm();
      this.form.attributeCategoryTenantId = categoryTenantId;
      this.form.attributeCategoryPlatformId = categoryPlatformId;
      this.visible = true;
      if (!this.unitOptions.length) {
        dictionaryData({ enableFlag: 1, typeCode: 'MEASURE_UNIT' }).then(res => {
          this.unitOptions = res.body || [];
        });
      }
      if (id) {
        this.loadDetail(id);
      } else {
        this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate());
      }
    },
    loadDetail (id) {
      getAttributeDetail({ id, source: this.currentSource }).then(res => {
        if (res.heads.code === 200) {
          const body = res.body || {};
          this.form = {
            name: body.name || '',
            remark: body.remark || '',
            valueType: body.valueType || '',
            valueRule: body.valueRule || '',
            timePrecision: body.timePrecision || '',
            hasUnitFlag: body.hasUnitFlag || false,
            unitName: body.unitName || '',
            isRange: body.isRange || false,
            decimalPlaces: body.decimalPlaces != null ? body.decimalPlaces : 2,
            attachmentTypeList: body.attachmentTypes ? body.attachmentTypes.split(',') : [],
            attachmentSize: body.attachmentSize || 10,
            valueList: (body.valueList || []).map(v => ({ ...v })),
            attributeCategoryTenantId: body.attributeCategoryTenantId || this.defaultCategoryTenantId,
          };
          this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate());
        }
      });
    },
    handleValueTypeChange () {
      this.form.valueList = [];
      this.form.valueRule = '';
      this.form.isRange = false;
    },
    handleValueRuleChange () {
      this.form.timePrecision = '';
      this.form.hasUnitFlag = false;
      this.form.unitName = '';
      this.form.isRange = false;
      this.form.decimalPlaces = 2;
      this.form.attachmentTypeList = [];
      this.form.attachmentSize = 10;
    },
    addValueRow () {
      this.form.valueList.push({ optionValue: '', isDefault: false, sort: this.form.valueList.length });
    },
    removeValueRow (index) {
      this.form.valueList.splice(index, 1);
    },
    handleDefaultChange (index) {
      if (this.form.valueType === 'SINGLE') {
        this.form.valueList.forEach((v, i) => { if (i !== index) v.isDefault = false; });
      }
    },
    handleSubmit () {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        this.submitting = true;
        const params = {
          ...this.form,
          id: this.currentId,
          attachmentTypes: (this.form.attachmentTypeList || []).join(','),
          valueList: this.form.valueList.filter(v => v.optionValue),
        };
        delete params.attachmentTypeList;
        const api = this.currentId ? updateAttribute : addAttribute;
        api(params).then(res => {
          if (res.heads.code === 200) {
            this.$message.success(this.currentId ? '更新成功' : '新增成功');
            this.visible = false;
            this.$emit('success');
          }
        }).finally(() => { this.submitting = false; });
      });
    },
  },
};
</script>

<style scoped lang="scss">
/deep/ .el-dialog__body {
  max-height: 65vh;
  overflow-y: auto;
  padding-top: 8px;
}
/deep/ .el-dialog__footer {
  border-top: 1px solid #E4E7ED;
}
</style>
